import { Toast } from '@tempmee/react';
import { useState } from 'react';
import { useLocation } from 'react-router';

export const REFERRAL_LINKED_STATE_KEY = 'referralLinked';

const REFERRAL_LINKED_MESSAGE = 'Referral linked successfully';
const REFERRAL_TOAST_AUTO_HIDE_MS = 3000;
export const REFERRAL_TOAST_ANCHOR = { vertical: 'bottom', horizontal: 'right' } as const;

export const ReferralLinkedToast = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(
    () => (location.state as Record<string, unknown> | null)?.[REFERRAL_LINKED_STATE_KEY] === true,
  );

  return (
    <Toast
      open={isOpen}
      message={REFERRAL_LINKED_MESSAGE}
      autoHideDuration={REFERRAL_TOAST_AUTO_HIDE_MS}
      anchorOrigin={REFERRAL_TOAST_ANCHOR}
      onClose={() => setIsOpen(false)}
    />
  );
};
